module.exports = __webpack_public_path__ + "static/bentonsanscond-book-webfont-cdcb9c96230bbd2c64081b3cc62d4f29.woff";